import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { ICheckDigitPro } from "../models/osd";
import { throwApiError } from "./apiError";

/**
 * GET Pro check digit detail API call using Axios
 */

export const checkPro = async (proNumber: string | number): Promise<ICheckDigitPro> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.CHECK_PRO)}/${proNumber}`);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.proImage, { badRequestOrder: "errorsFirst" });
  }
};
